import {
  Resource_AppointmentTaskDueStage,
  Resource_AppointmentTaskType,
} from '@/generated/graphql';

export default {
  'appointment-tasks': 'Appointment tasks',
  'appointment-tasks.task-completed': 'Task completed!',
  'appointment-tasks.title-unknown': '<Untitled>',
  'appointment-tasks.reason-for-cancellation': 'Reason for cancellation: {reasons}',
  'appointment-tasks.reason-for-cancellation.missing': 'No reason provided',

  'appointment-tasks.info.empty': 'No further information available.',
  'appointment-tasks.info.mark-as-read': 'Mark as read',
  'appointment-tasks.info.marked-as-read': 'Read',

  'appointment-task.document-upload': 'File upload',
  'appointment-task.document-upload.complete': 'Completed',
  'appointment-task.document-upload.dragger.title': 'Upload file',
  'appointment-task.document-upload.dragger.title.edit': 'Upload different file',

  'appointment-task.document-download.description': 'A document is available for you to download.',
  'appointment-task.document-download.download': 'Download document',
  'appointment-task.document-download.download-again': 'Download again',

  'appointment-task.form.start-form': 'Complete survey',
  'appointment-task.form.continue-form': 'Continue survey',
  'appointment-task.form.form-completed': 'Survey completed',

  'appointment-task.type.title.not-present': 'Title not available',

  [Resource_AppointmentTaskType.AppointmentTaskTypeForm]: 'Fill out form',
  [Resource_AppointmentTaskType.AppointmentTaskTypeInfo]: 'View information',
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentDownload]: 'Download file',
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentUpload]: 'Upload file',

  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageBeforeAppointment]: 'Before appointment',
  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageDuringAppointment]: 'During appointment',
  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageAfterAppointment]: 'After appointment',

  'appointment.notes': 'Notes',
  'appointment.note': 'Note',
  'appointment.edit-note': 'Edit note',
  'appointment.add-note': 'Add note',
  'appointment.delete-note.are-you-sure': 'Are you sure you want to delete this note?',
  'appointment.enter-note': 'Enter note',
};
